import { ActivityType, AgendaItemActionPlanTopic, ArticleChangeImportance, BasicActionPlanTopic, SegmentReport, SimpleActionPlanTopic, SurveyActionPlanTopic, SurveySegment } from '.';

//... and the ActionPlanTypes array
export const ActionPlanTypes = ['WPA', 'Independent', 'Article', 'Meeting'] as const;
export type ActionPlanType = typeof ActionPlanTypes[number];

export type ActionPlanOwner =
    { type: 'MemberUser', userId: string, fullName: string } |
    { type: 'RegularUser', userId: string, fullName: string };


type CommonActionPlan = {
    id: string,
    activityId: string,
    activityType:ActivityType,
    activityTitle: string,
    start:Date,
    end:Date,
    title:string,
    description: string,
    type: ActionPlanType,
    owner: ActionPlanOwner | null
}

type IndependentActionPlanTypeData = { 
    type: 'Independent' 
};
type ArticleActionPlanTypeData = { 
    type: 'Article', 
    customData:{ 
        articleId:string 
    } 
};
type WorkplaceAssessmentActionPlanTypeData = { 
    type: 'WPA', 
    customData:{ 
        surveyId: string,
        segmentFilter: SurveySegment[][] 
    } 
};
type MeetingActionPlanTypeData = { 
    type: 'Meeting',
    customData: {
        hidden: boolean
    }
};

// These fields are specific to the type of action plan
// CustomData contents is serialized to JSON in the DB custom_data field
export type ActionPlanTypeData =
    IndependentActionPlanTypeData |
    ArticleActionPlanTypeData |
    WorkplaceAssessmentActionPlanTypeData |
    MeetingActionPlanTypeData;

// This is used for reading data from the DB where we don't need the full ActionPlanView
export type SimpleActionPlanView =
    (CommonActionPlan & IndependentActionPlanTypeData & { topics: SimpleActionPlanTopic[] }) |
    (CommonActionPlan & ArticleActionPlanTypeData & { topics: SimpleActionPlanTopic[] }) |
    (CommonActionPlan & WorkplaceAssessmentActionPlanTypeData & { topics: SimpleActionPlanTopic[] }) |
    (CommonActionPlan & MeetingActionPlanTypeData & { topics: SimpleActionPlanTopic[] });

export type SurveyActionPlanView = 
    CommonActionPlan & 
    WorkplaceAssessmentActionPlanTypeData &
    {
        topics:(SurveyActionPlanTopic | BasicActionPlanTopic)[],
        surveyData: {
            surveyAnswerCount: number,
            segmentReport: SegmentReport[]
        }
    };

export type IndependentActionPlanView =
    CommonActionPlan & 
    IndependentActionPlanTypeData &
    {
        topics:BasicActionPlanTopic[]
    };

export type ArticleActionPlanView =
    CommonActionPlan & 
    ArticleActionPlanTypeData &
    {
        topics:BasicActionPlanTopic[]
        articleData:{
            isDeleted: boolean,
            title: string,
            description: string,
            reference: string,
            list: {
                id: string,
                name: string,
            };
            topic: {
                id: string,
                name: string;
            },
            date: Date | null,
            url: string,
            owner: {
                userId:string,
                displayName:string,
                initials:string
            } | null,
            importance:ArticleChangeImportance,
            categoryTag:string
        }
    };

export type MeetingActionPlanView =
    CommonActionPlan & 
    MeetingActionPlanTypeData &
    {
        topics:AgendaItemActionPlanTopic[]
    };

export type ActionPlanView = SurveyActionPlanView | IndependentActionPlanView | ArticleActionPlanView | MeetingActionPlanView;

